import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CtaBlock } from './CtaBlock';
import { withSystem, withoutSystem } from '../data/content';
export function Comparison() {
  return <section className="bg-navy-900 py-14 sm:py-20" data-id="element-73" data-mp="1l5uj392nmseb">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-74" data-mp="1pyns4955omw7">
        <SectionHeading eyebrow="Prima e dopo" tone="dark" title="Dall’incertezza clinica a un processo decisionale più chiaro" data-id="element-75" data-mp="1q074honoydsp" />

        <div className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-76" data-mp="1zuz7x93yfuve">
          <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-5 sm:p-6" data-id="element-77" data-mp="23y5b27vrt5xn">
            <h3 className="flex items-center gap-2 text-[13px] font-black uppercase tracking-[0.12em] text-red-300 sm:text-sm" data-id="element-78" data-mp="28wq9c1rgpfjg">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-red-500/20" data-id="element-79" data-mp="9kxkwtiqpiic">
                <XIcon className="h-3.5 w-3.5 text-red-300" aria-hidden="true" data-id="element-80" data-mp="ek0ffk13g6c2" />
              </span>
              Prima — senza il sistema
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-81" data-mp="1ha0l0wt6wkge">
              {withoutSystem.map(item => <li key={item} className="flex gap-3 text-[14px] leading-snug text-white/70 sm:text-[15px]" data-id="element-82" data-mp="1h85yxf66mmaq">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-400" aria-hidden="true" data-id="element-83" data-mp="189atw6evji90" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="rounded-2xl border border-gold-500/30 bg-gold-500/[0.07] p-5 shadow-[0_20px_45px_-25px_rgba(201,162,39,0.6)] sm:p-6" data-id="element-84" data-mp="24x8r3gyfzxjh">
            <h3 className="flex items-center gap-2 text-[13px] font-black uppercase tracking-[0.12em] text-gold-300 sm:text-sm" data-id="element-85" data-mp="1vy3pg1rl3o33">
              <span className="flex h-6 w-6 items-center justify-center rounded-full bg-gold-500/25" data-id="element-86" data-mp="1qzk4o4oq8icb">
                <CheckIcon className="h-3.5 w-3.5 text-gold-200" aria-hidden="true" data-id="element-87" data-mp="kl1d5iwipkoq" />
              </span>
              Dopo — con il sistema
            </h3>
            <ul className="mt-4 space-y-3" data-id="element-88" data-mp="h1kcq3hbhu5k">
              {withSystem.map(item => <li key={item} className="flex gap-3 text-[14px] font-medium leading-snug text-white sm:text-[15px]" data-id="element-89" data-mp="m1f56bgqqrsq">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold-400" aria-hidden="true" data-id="element-90" data-mp="802pm15hss7d" />
                  {item}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex justify-center" data-id="element-91" data-mp="3ufx5ts4cr52b">
          <CtaBlock tone="dark" label="Passa al sistema strutturato — 19 EUR" note="Accesso immediato · Pagamento unico" data-id="element-92" data-mp="3217pjjsyyxh" />
        </div>
      </div>
    </section>;
}